export default [
  'name',
  'short_name',
  { key: 'action', label: '' }
]
